/**
 * @copyright 2016-present Kriasoft (https://git.io/Jt7GM)
 */

import { graphql } from "relay-runtime";
import type { Route } from "../../core";
import type Home from "./Home";
import type { homeQueryResponse } from "./__generated__/homeQuery.graphql";

/**
 * Homepage route.
 */
export default {
  path: "/",
  query: graphql`
    query homeQuery {
      me {
        id
        name
        email
      }
      works {
        ...WorkListFragment_works
      }
    }
  `,
  component: () => import(/* webpackChunkName: "home" */ "./Home"),
  response: (data) => ({
    title: data.me
      ? "Goodparts"
      : "Goodparts · Discover the good parts in any book",
    description:
      "Goodparts makes it easier to discuss the specific topics and highlights from the books you read.",
    props: data,
  }),
} as Route<typeof Home, homeQueryResponse>;
